function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteDx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.68 24.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.53,24.95L16.01,0H3.54L0,24.95h9.53ZM28.19,24.95L34.68,0h-12.47l-3.54,24.95h9.53Z",
    style: {
      fill: "#164891"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteDx);
export default __webpack_public_path__ + "static/media/quote-dx.cc19c8167ce8c890cfd95e223709be2d.svg";
export { ForwardRef as ReactComponent };